<template>
    <div class="block">
        <div>

        </div>
        <van-grid>
            <swipe-image/>
        </van-grid>
        <van-grid clickable :column-num="2"   icon-size="32" class="gridwarp" >
            <van-grid-item icon="search" text="质保书查询" to="/Home/WarrantyBookTh" />
        </van-grid>
    </div>
</template>

<script>
    import SwipeImage from "../components/SwipeSearchImage";
    import { Grid, GridItem } from 'vant';

    export default {
        name: "Search",
        components:{
            SwipeImage:SwipeImage,
            [Grid.name]:Grid,
            [GridItem.name]:GridItem
        }
    }
</script>

<style scoped>
    .block{
        top:0px;
        width:100%;
        height: 100vh;
        overflow-y: scroll;
        -webkit-overflow-scrolling: touch;
    }
    .gridwarp{
        width:95%;
        margin:10px auto 0 auto;
        background: #ffffff;
        border-radius: 10px;
        color:#6685a4;
    }
    /deep/ .van-grid-item__content{
        border-radius: 10px;
    }
    /deep/ .van-grid-item__text {
        font-size: 14px;
    }
</style>